/**
 * @namespace Podcast
 * @aka Planet.Podcast
 */
Planet.Podcast = (function ($) {

    /**
     * ------------------------------------------------------------------------
     * Constants
     * ------------------------------------------------------------------------
     */

    var NAME = 'podcast';
    var DATA_KEY = 'planet.' + NAME;
    var EVENT_KEY = '.' + DATA_KEY;
    var DATA_API_KEY = '.data-api';
    var JQUERY_NO_CONFLICT = $.fn[NAME];

    var Event = {
        PJAX_DATA_API: 'pjax:end' + EVENT_KEY + DATA_API_KEY
    };

    var Selector = {
        DATA_SPY: 'input[type="text"][data-spy="clipboard"]'
    };

    /*
     TODO: private helpers go here.
     */

    /**
     * ------------------------------------------------------------------------
     * Class Definition
     * ------------------------------------------------------------------------
     */
    var Podcast = function () {

        function Podcast(element) {
            var self = this;

            // protected
            self.element = element;
            self.$element = $(self.element);

            // button hinzufügen
            self._renderButton();

            // formular korrigieren
            self._fixMarkup();
        }

        Podcast.prototype._fixMarkup = function _fixMarkup() {
            var self = this;

            var $panelPodcast = self.$element.closest('.panel-podcast .panel-body');
            if (0 === $panelPodcast.length) {
                return;
            }

            var $figure = $panelPodcast.find('figure');
            var $form = $panelPodcast.find('.form');

            var windowWidth = window.screen.width < window.outerWidth ? window.screen.width : window.outerWidth;
            var mobile = windowWidth < 500;

            if(0 === $figure.length && !mobile) {
                $form.find('input').css('width', '85%');
            }else if(0 === $figure.length && mobile){
                $form.find('input').css('width', '80%');
            }
            $figure.addClass('figure-left');
            $form.addClass('form-podcast');
        };

        Podcast.prototype._renderButton = function _renderButton() {
            var self = this;

            self.$element.wrap('<div class="copy-adress"></div>');

            self.$button = $(COMMON.Utils.template('<button class="btn btn-secondary" type="button" id="button-addon2" data-clipboard-target="#{inputId}" title="In Zwischenablage kopieren">' +
                '<i class="icon-clipboard"></i>' +
                '<span class="sr-only">In Zwischenablage kopieren</span>' +
                '</button>', {
                inputId: self.$element.attr('id')
            }));

            self.$element.after(self.$button);

            // bind ClipboardJS to $button
            $(document).trigger('common:clipboard:bind-element', {$trigger: self.$button});
        };

        // public
        Podcast.prototype.dispose = function dispose() {
            this.$element.off(EVENT_KEY);

            this.$element.unwrap('.copy-adress');
            this.$button.remove();

            this.$element = null;
            this.element = null;

            $(document).off(EVENT_KEY);
        };

        // static
        Podcast._jQueryInterface = function _jQueryInterface() {
            return this.each(function () {
                var data = $(this).data(DATA_KEY);

                if (!data) {
                    data = new Podcast(this);
                    $(this).data(DATA_KEY, data);
                }
            });
        };

        return Podcast;
    }();

    /**
     * ------------------------------------------------------------------------
     * Data Api implementation
     * ------------------------------------------------------------------------
     */
    $(Selector.DATA_SPY).each(function () {
        var $element = $(this);
        Podcast._jQueryInterface.call($element, $element.data());
    });
    $(document).on(Event.PJAX_DATA_API, function (event, xhr, options) {
        $(options.container).find(Selector.DATA_SPY).each(function () {
            var $element = $(this);
            Podcast._jQueryInterface.call($element, $element.data());
        });
    });

    /**
     * ------------------------------------------------------------------------
     * jQuery
     * ------------------------------------------------------------------------
     */
    $.fn[NAME] = Podcast._jQueryInterface;
    $.fn[NAME].Constructor = Podcast;
    $.fn[NAME].noConflict = function () {
        $.fn[NAME] = JQUERY_NO_CONFLICT;
        return Podcast._jQueryInterface;
    };

    return Podcast;

})(window.jQuery);
